import * as React from 'react';
import { LinkButton, Responsive } from '@cian/ui-kit';

import { IconActionArrowUpRight16, IconProductSpecialLoanRate24 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './BankItem.css';
import { AuthorLabel } from '../AuthorLabel';

export interface IBankItemProps {
  label?: string | null;
  logoUrl?: string | null;
  mortgagePartnerLink?: string | null;
  name: string;
  onMortgageClick?(): void;
}

export const BankItem: React.FC<IBankItemProps> = ({ label, logoUrl, mortgagePartnerLink, name, onMortgageClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['info']}>
        <AuthorLabel name={name} label={label} logoIcon={<IconProductSpecialLoanRate24 />} logoUrl={logoUrl} />
      </div>

      {mortgagePartnerLink && (
        <div className={styles['link']}>
          <Responsive desktop>
            <LinkButton href={mortgagePartnerLink} onClick={onMortgageClick} theme="fill_secondary" size="M" fullWidth>
              Получить ипотеку онлайн
            </LinkButton>
          </Responsive>
          <Responsive tablet phone>
            <LinkButton
              target="_blank"
              beforeIcon={<IconActionArrowUpRight16 color="icon-main-default" />}
              href={mortgagePartnerLink}
              onClick={onMortgageClick}
              theme="fill_white_primary"
              size="M"
            ></LinkButton>
          </Responsive>
        </div>
      )}
    </div>
  );
};
